
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Afegeix-lo a la teva pantalla d'inici per a una àmplia experiència i fàcil accés.`,
's224cbcec014ef6b5': `Premeu comparteix a la barra de navegació`,
's37a9e8aec5713460': `Més`,
's386eca8362ff6155': `Premeu "Més" si no hi ha icona de Compartir`,
's4e1e10a6ca408245': `Toca "Afegeix a la pantalla d'inici"`,
's6196153c4b0c1ea0': `Instal·la`,
's633502f7cff4f847': `Obre el menú del navegador`,
's681e399d63311fba': `Mostra la galeria`,
's7f0591f08e318eda': `Premeu "Més" al menú de Compartir`,
's8114bd55cae5a22b': `Premeu "Afegeix al Dock"`,
's922329d6f6213590': `Afegeix al Dock`,
's9af56bf005b49c74': `Desplaça't cap avall fins a "Afegeix a la pantalla d'inici"`,
'sa5ef80b4bb9b39f8': `Menys`,
'sba52286c21552a4e': `Instal·la'l al teu dispositiu per a una àmplia experiència i fàcil accés.`,
'sc16e00a7a8b2fde2': `Enrere`,
'scdaf4bbff76674c8': `Afegeix a pantalla d'inici`,
'se0e473adfda8066c': `Obre al navegador principal`,
'se740f75b95a51807': `Afegeix-lo al teu Dock per a una àmplia experiència i fàcil accés.`,
'sfea652f6580ff086': `Aquest lloc té funcionalitats d'aplicació.`,
    };
  